import * as StageStatus from '../../stageStatus';
import Utils from '../../utils/util';
import { getInstance } from './get';
import { updateTransformConfig } from './updateConfig';
import { shelfPaintTotalWidth, shelfsPaintMaxHeight } from '../../UIToolkit/shelf/shelfCodi';
import { freezerPaintTotalWidth, freezerPaintMaxHeight } from '../../UIToolkit/freezer/freezerCodi';

interface ShelfPaintSize {
    width: LogicsicsMeasurement,
    height: LogicsicsMeasurement
};

function moveTo(codi: LogicPosition): void {
    let stageMatrix: MatrixInstance = getInstance();

    stageMatrix.moveTo(codi);
    updateTransformConfig();
}

function moveToCenter(): void {
    let $sketchpad: JQuery<HTMLElement> = $('.shelvesbuild-e-sketchpad');
    let shelfPaintSize: ShelfPaintSize = getShelfPaintSize();
    let shelfAreaWidth: LogicsicsMeasurement = shelfPaintSize.width;
    let shelfAreaHeight: LogicsicsMeasurement = shelfPaintSize.height;
    let left: LogicsicsMeasurement = Utils.math($sketchpad.width(), shelfAreaWidth, '-');
    let top: LogicsicsMeasurement = Utils.math($sketchpad.height(), shelfAreaHeight, '-');

    left = Utils.math(left, 2, '/');
    top = Utils.math(top, 2, '/');
    moveTo({
        left,
        top
    });
}

function getShelfPaintSize(): ShelfPaintSize {
    if (StageStatus.isTopFace()) {
        return {
            width: freezerPaintTotalWidth(),
            height: freezerPaintMaxHeight()
        };
    }

    return {
        width: shelfPaintTotalWidth(),
        height: shelfsPaintMaxHeight()
    };
}

export {
    moveTo,
    moveToCenter
};
